if (!customElements.get('colour-picker')) {
	class ColourPicker extends HTMLElement {
		constructor() {
			super();
      this.pickerDrawerInput = document.getElementById('cp-search-drawer-input');
      const drawerElement = document.querySelector('.js-colour-picker-drawer');
			const pickerSearchInput = document.getElementById('cp-search-input');
      // const pickerSearchInputBtn = document.querySelector('colour-picker .input-with-button button');
			const showPickerDrawerBtn = document.querySelector('.js-show--colour-picker');
			this.buttonOpenDrawer(showPickerDrawerBtn, drawerElement);
			// this.inputOpenDrawer(pickerSearchInput, drawerElement);
		}

		buttonOpenDrawer(button, drawer) {
			if (button) {
				button.addEventListener('click', () => {
					if (drawer instanceof ColourPickerDrawer) {
						drawer.open(drawer);
					}
				});
			}
		}

		inputOpenDrawer(input, drawer) {
      //Input enter event
      input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          this.passInputValue(drawer, input.value.toLowerCase());
        }
      });

      //Input button event
      const button = input.parentElement.querySelector('button.btn');
      if (button) {
        button.addEventListener('click', (event) => {
          this.passInputValue(drawer, input.value.toLowerCase());
        });
      }
		}

    passInputValue(drawer, value) {
      if (drawer instanceof ColourPickerDrawer && value) {
        this.pickerDrawerInput.value = value;
			  const colorItems = document.querySelectorAll('#drawer__content-colour-list li');
        colorItems.forEach((item) => {
          const colorName = item.getAttribute('data-name');
          const colorCat = item.getAttribute('data-cat');
          const hexCode = item.getAttribute('data-hex');
          if (colorName.includes(value) || (colorCat.includes(value)) || (hexCode.includes(value))) {
            item.style.display = 'grid';
          } else {
            item.style.display = 'none';
          }
        });

        drawer.open(drawer);
      }
    }
	}
	customElements.define('colour-picker', ColourPicker);
}
